













import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class SidebarNavTitle extends Vue {
  @Prop({ default: "" })
  public name: string;

  @Prop({ default: "" })
  public classes: string;

  @Prop()
  public wrapper: any;

  get classList() {
    return ["nav-title", ...this.itemClasses];
  }

  get itemClasses() {
    return this.classes ? this.classes.split(" ") : [];
  }
}
